<template>
  <div>
    <div class="testimonials testimonials-background">
      <img src="@/assets/images/quote.png" />
      <p>
        “Woww!!! It is like coming out of the "dark ages"... Thanks for the class. It is not too much chemistry for me because it is so colorful and fun.”
      </p>
      <p class="testimonials-box nomargin">
        <img src="@/assets/powerdrops/testimonial-kristin.png" />
        <span class="testimonials-info">
          <span class="testimonials-name">Kristín Sjofn</span>
          Aromatherapist and Educator
        </span>
      </p>
    </div>
    <div class="testimonials testimonials-background">
      <img src="@/assets/images/quote.png" />
      <p>
        I just watched Lesson One. LOVED IT!!! Wrote a full page of notes. I absolutely LOVE learning and feel SO fortunate I found Dropsmart. I can't wait for the next lesson. VERY informative.
                  Melani, you have inspired and motivated me to continue my aromatherapy journey. I appreciate you very much. Your team as well. Leandro has been phenomenal assisting me when I've had technical problems!!
                  Please continue to include chemistry education as I feel it is truly important for the overall understanding of using and blending.
      </p>
      <p class="testimonials-box nomargin">
        <img src="@/assets/powerdrops/testimonial-tammy.png" />
        <span class="testimonials-info">
          <span class="testimonials-name">Tammy Kell</span>
          Aromatherapist
        </span>
      </p>
    </div>
    <div class="testimonials testimonials-background">
      <img src="@/assets/images/quote.png" />
      <p>
        I absolutely LOVE Dropsmart! And I love our Next Level Power Drops course! I go on every day and check out different conditions and then look at which are the best oils for that condition. I'm always surprised at what I find!
      </p>
      <p class="testimonials-box nomargin">
        <img src="@/assets/powerdrops/testimonial-sylvia.png" />
        <span class="testimonials-info">
          <span class="testimonials-name">Sylvia Provenski</span>
          Nurse and Aromatherapist
        </span>
      </p>
    </div>
    <h2 class="textMoneyback" v-if="this.routeName != 'GiftCard'">
      30-Day No-Questions-Asked Money-Back Guarantee
    </h2>
    <p class="text-riskFree" v-if="this.routeName != 'GiftCard'">
      We guarantee that the course materials are original, that you'll receive technical support for your best experience, and that your purchase is protected by a no-questions-asked 30-day money-back guarantee.
    </p>
  </div>
</template>

<style lang="scss">
.textMoneyback {
  color: #434343;
  font-size: 30px;
  font-weight: 700;
  margin-bottom: 19px;
  margin-top: 50px;
}

.text-riskFree {
  font-size: 18px;
  color: #434343;
  margin-bottom: 70px;
}

.testimonials {
  background: #f7f7f7;
  margin-bottom: 20px;
  padding: 40px 45px;
  img {
    margin-bottom: 25px;
    max-width: 80px;
  }
  p {
    color: #545454;
    font-size: 20px;
    line-height: 30px;
    img {
      margin: 0;
    }
  }
  .nomargin {
    margin: 0;
  }
  .testimonials-box {
    display: flex;
    align-items: center;
    img {
      align-self: center;
      margin-right: 30px;
    }
  }
  .testimonials-info {
    color: #545454;
    display: flex;
    flex-direction: column;
    font-size: 14px;
    font-weight: 400;
    line-height: 18px;
    max-width: 300px;
    .testimonials-name {
      font-size: 18px;
      font-weight: 700;
      margin-bottom: 5px;
    }
  }
}
</style>

<script>

export default {
  name: "NextLevelAromaEmpressLeft",
  props: ['routeName'],
}
</script>
